import React from "react";
import { useSelector } from "react-redux";
import AllGymOfferStructure from "../../components/offer-mapping/all-gym-offers/AllGymOfferStructure";
import { selectUser } from "../../components/auth/auth.selector";

const AllGymOffers = () => {
  const userInfoData = useSelector(selectUser);

  return <AllGymOfferStructure userInfoData={userInfoData} />;
};

export default AllGymOffers;